import { CellClassParams, CellStyleFunc } from 'ag-grid-community'
import { RoleRow } from '../../model/RoleRow'

const DISABLE_COLOR = '#bdbdbd'

export const cellStyle: CellStyleFunc<RoleRow> = (
  params: CellClassParams<RoleRow>
) => {
  if (!params.data?.editable) {
    return { backgroundColor: DISABLE_COLOR }
  }
  return undefined
}
